import { listStorageKeys, removeFromStorage } from './use-storage'
import {
  BUSINESS_STORAGE_KEY,
  REPORTS_STORAGE_KEY,
  SUBSCRIPTION_REFRESHED_STORAGE_KEY,
  SUBSCRIPTION_STORAGE_KEY,
  USER_AUTH_STORAGE_KEY,
} from './use-storage.constants'

export function clearBusinessStorage() {
  removeFromStorage(BUSINESS_STORAGE_KEY)
  removeFromStorage(SUBSCRIPTION_STORAGE_KEY)
  removeFromStorage(SUBSCRIPTION_REFRESHED_STORAGE_KEY)
}

export function clearReportStorage() {
  const allKeys = listStorageKeys()
  allKeys.forEach(key => {
    if (key.startsWith(REPORTS_STORAGE_KEY)) {
      removeFromStorage(key)
    }
  })
}

export function clearUserAuthStorage() {
  removeFromStorage(USER_AUTH_STORAGE_KEY)
}
